import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Apiconnect from "../services/Apiconnect.js";

import './mycss.css';

const OtpVerify = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const emailFromStorage = localStorage.getItem("email");
    if (emailFromStorage) {
      setEmail(emailFromStorage);
    }
    localStorage.removeItem("email");
  }, []);

  useEffect(() => {
    console.log("Updated email:", email);
  }, [email]);


  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Auto-focus to the next input box
    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const enteredOtp = otp.join("");
    const infoz = { otp: enteredOtp, email };

    try {
      const response = await Apiconnect.postDataNoauth("auth/verify-customer", infoz);
      console.log(response.data);

      if (response.data.status === 1) {
        toast.success('Verified Successfully');
        setTimeout(() => {
          navigate("/login", { replace: true });
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
      setIsLoading(false);

    } catch (error) {
      const err = error?.response?.data?.message || 'Something went wrong!!';
      console.error("API Error:", error);
      toast.error(err);
    }
  };


  return (
    <>
      <div className="container-fluid p-0 vh-100">
        <div className="row g-0 vh-100">
          <div className="col-xl-7 example" style={{ backgroundImage: `url(admin_codebase/bgpic1.jpg)` }}></div>

          <div className="col-xl-5 vh-100">
            <div className="auth-full-page-content p-md-5 p-4">
              <div className="w-100 p-5">
                <div className="text-center">
                  <img style={{ maxWidth: "50%", marginBottom: 30 }} src="admin_codebase/b-logo.png" alt="Logo" />
                  <h2><b>OTP Verification</b></h2>
                  <h6>We have sent an OTP to your email: <b style={{ color: "blue" }}>{email}</b></h6>
                </div>

                <form onSubmit={handleSubmit} className="mt-4">
                  <div className="d-flex justify-content-center">
                    {otp.map((data, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength="1"
                        className="otp-input"
                        value={data}
                        onChange={(e) => handleChange(e.target, index)}
                        onFocus={(e) => e.target.select()}
                        style={{
                          width: "50px",
                          height: "50px",
                          margin: "0 5px",
                          textAlign: "center",
                          fontSize: "20px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      />
                    ))}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100 mt-4"
                    disabled={isLoading}
                  >
                    {isLoading ? "Please wait..." : "Verify OTP"}
                  </button>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default OtpVerify;